// Footer Component
import React, { useState } from 'react';
import TermsModal from './TermsModal';
import PrivacyModal from './PrivacyModal';
import './Footer.css';

const Footer: React.FC = () => {
    const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
    const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    const currentYear = new Date().getFullYear();

    const phoneNumber = '+447944488611';
    const phoneDisplay = '079 444 88 611';

    const handleCopyPhone = async () => {
        try {
            await navigator.clipboard.writeText(phoneNumber);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <>
            <footer className="site-footer">
                <div className="footer-content">
                    <div className="footer-section">
                        <h3>Deli Feed</h3>
                        <p>Freshly made and delivered from our family kitchen in Upper Cambourne.</p>
                    </div>

                    <div className="footer-section">
                        <h4>Contact Us</h4>
                        <p>
                            📱 <a href="https://wa.me/447944488611" target="_blank" rel="noopener noreferrer" className="footer-link">WhatsApp</a> / <a href="tel:+447944488611" className="footer-link">Mobile</a>:<br />
                            <span className="phone-number-container">
                                <button onClick={handleCopyPhone} className="phone-copy-button" title="Copy phone number">
                                    {phoneDisplay} {copied ? '✓' : '📋'}
                                </button>
                            </span>
                        </p>
                    </div>

                    <div className="footer-section">
                        <h4>Legal</h4>
                        <ul className="footer-links">
                            <li>
                                <button
                                    onClick={() => setIsTermsModalOpen(true)}
                                    className="footer-link-button"
                                >
                                    Terms & Conditions
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => setIsPrivacyModalOpen(true)}
                                    className="footer-link-button"
                                >
                                    Privacy Policy
                                </button>
                            </li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Follow Us</h4>
                        <div className="footer-social-links">
                            <a
                                href="https://www.facebook.com/DeliFeed"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-social-btn facebook"
                                title="Follow us on Facebook"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                </svg>
                                <span>Facebook</span>
                            </a>
                            <a
                                href="https://www.instagram.com/delifeed_cambourne"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-social-btn instagram"
                                title="Follow us on Instagram"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                                </svg>
                                <span>Instagram</span>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {currentYear} Deli Feed. All rights reserved.</p>
                </div>
            </footer>

            <TermsModal
                isOpen={isTermsModalOpen}
                onClose={() => setIsTermsModalOpen(false)}
            />

            <PrivacyModal
                isOpen={isPrivacyModalOpen}
                onClose={() => setIsPrivacyModalOpen(false)}
            />
        </>
    );
};

export default Footer;
